export default {
  Title: 'Patho Statistic 01',
  DateReceiveFrom: 'Date Received From',
  DateReceiveTo: 'To',
  PathoNo: 'Patho No.',
  HLN: 'HLN',
  ReportType: 'Report Type',
  PatientName: 'Patient Name',
  ReceivedDate: 'Received Date',
  Find: 'Find',
  Day: 'รายวัน',
  Month: 'รายเดือน',
  Year: 'รายปี',
}
